import type { ScanSiteV1OutputDto } from 'generated/apiSchemas';
import { db } from 'technical/db';

export const getScanSitesService = {
  set: async (input: ScanSiteV1OutputDto) => {
    const scanSites = input.scanSites.map((scanSite) => ({
      id: scanSite.id,
      name: scanSite.label,
      isQuarantineEnabled: scanSite.isQuarantineEnabled ?? true,
      isOnHoldOptionEnabled: scanSite.isOnHoldOptionEnabled ?? false,
    }));
    await db.scanSites.bulkPut(scanSites);
  },

  get: async () => {
    const scanSites = await db.scanSites.toArray();
    return {
      scanSites: scanSites.map((scanSite) => ({
        id: scanSite.id,
        label: scanSite.name,
        scanMode: '',
        isQuarantineEnabled: scanSite.isQuarantineEnabled ?? true,
        isOnHoldOptionEnabled: scanSite.isOnHoldOptionEnabled ?? false,
      })),
    };
  },
};
